import React, { Component } from 'react';

import Color from './Color';

class NormalCard extends Component {
  constructor(props){
    super(props);
    
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick (e, data) {
    const info = Object.assign({}, this.props);
    delete info.onClick;
    this.props.onClick(info);
  }

  render() {

    const {
      epgid,
      start,
      stop,
      duration,
      chname,
      title,
      desc,
      category,
      director,
      actor,
      rating,
      thumbnail,
      active,

      color,
      onClick,
      onDobbleClick
    } = this.props;


    const contentStyle = {
      backgroundColor: color,
      border: `1px solid ${ Color.darken(color, 60)}`
    };
    const height = 3*duration; // NOTE: 1분에 3px;
    const hourCell = 3 * 60 + 4; // NOTE: Timetable에서 1시간에 해당하는 셀의 높이

    const cardStyle = {
      height: `${height}px`,
      top: `${hourCell*(start.minutes()/60) + start.hours()*hourCell}px`
    };

    

    const thumbnailStyle = {
      backgroundPosition: 'center',
    };
    if(thumbnail) thumbnailStyle.backgroundImage = `url(${thumbnail})`;
    else {
      thumbnailStyle.border = '1px solid #c1c1c1';
      thumbnailStyle.backgroundColor = '#f1f1f1';
    }

    const clamp = Math.floor((height-22) / 18);
    const descEllipsis = {
      maxHeight: `${clamp*18}px`,
      WebkitLineClamp: clamp
    };
    const descStr = desc ? desc.split('\n').map((item, index) => [item,  <br key={'normalCardindex'+index}/>]) : null;


    const tooltipText = `방송시작: ${start.format("MM/DD HH:mm")}
    방송종료: ${stop.format("MM/DD HH:mm")}`;


    const contentClasses = 'content ' + (active ? ' active' : '');

    return (
      <div className='card normal' style={cardStyle}>
        <div className='time'>{start.minutes()}</div>
        <div className={contentClasses} style={contentStyle} data-tip={tooltipText} tabIndex={0} onDoubleClick={onDobbleClick}>
          <div className='thumbnail' style={thumbnailStyle}>
            {active ? <div className='thumbnail-border'></div> : null }
          </div>
          <div className='description' style={descEllipsis}>
            {title}
            <div className='memo'>{descStr}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default NormalCard;


// WEBPACK FOOTER //
// ./src/components/card/NormalCard.js